// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface LocationFinderHeaderStyles {}

export const inviteYourColleagueHeaderHeaderStyles: LocationFinderHeaderStyles = {};

const styles = inviteYourColleagueHeaderHeaderStyles;

const LocationFinderHeader: FC<Props> = ({ id, pageTitle }) => {
    return (
        <OrderHeader title={pageTitle}>
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(LocationFinderHeader),
    definition: {
        group: "Location Finder",
        displayName: "Header",
        allowedContexts: ["LocationFinderPage"],
    },
};

export default widgetModule;
